import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { Message } from "primereact/message"
import PropTypes from "prop-types"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { updateState } from "../../../utils/utils"

const SocialRow = (props) => {
  const {
    drop,
    setDrop,
    num,
    setNum,
    numError,
    numErrorType,
    removeError,
    legend,
    options,
    dropError,
    dropErrorType,
    summaryDisabled,
    showNumber,
    entity,
    setEntity,
    defaultZero,
    required
  } = props
  return (
    <div className={gpraStyles.socialRowContainer}>
      <div className={gpraStyles.socialRowLabel}>
        <label className={gpraStyles.ml1}>{legend}{required && <span className={gpraStyles.required}> *</span>}</label>
      </div>
      <Dropdown
        className={dropError ? gpraStyles.input4Error : gpraStyles.input4}
        value={drop}
        onChange={(e) => {
          updateState(setDrop, e.value, null, null, entity, setEntity, null)
          removeError(numErrorType)
          removeError(dropErrorType)
        }}
        options={options}
        optionLabel="label"
        optionValue="value"
        showClear={drop}
        disabled={summaryDisabled}
      />
      {showNumber && (
        <div>
          <InputNumber
            className={gpraStyles.inputNumber}
            value={!num && defaultZero ? 0 : num}
            onValueChange={(e) => {
              updateState(setNum, e.value, null, null, entity, setEntity, null)
              removeError(numErrorType)
            }}
            showButtons
            disabled={drop !== "Yes" || summaryDisabled}
            suffix=" Times"
            min={0}
            inputClassName={numError && gpraStyles.numberError}
          />
        </div>
      )}
      <div className={gpraStyles.ml1}>
        {numError && <Message severity="error" text={numError} />}
        {dropError && (
          <Message className="px-0" severity="error" text={dropError} />
        )}
      </div>
    </div>
  )
}
SocialRow.propTypes = {
  drop1: PropTypes.string,
  setDrop1: PropTypes.func,
  num: PropTypes.number,
  setNum: PropTypes.string,
  numError: PropTypes.string,
  numErrorType: PropTypes.string,
  removeError: PropTypes.func,
  legend: PropTypes.string,
  options1: PropTypes.array,
  dropError: PropTypes.string,
  drop1ErrorType: PropTypes.string,
  summaryDisabled: PropTypes.bool,
  showNumber: PropTypes.bool,
}

SocialRow.defaultProps = {
  showNumber: false,
}

export default SocialRow
